<script>
import Navbar from 'layouts/errors/Navbar.svelte';
import Footer from 'layouts/my/Footer.svelte';


import { auth, my } from 'store/index.js';


import { Route, navigateTo } from 'svelte-router-spa';
import { onMount } from 'svelte';
import { get } from 'svelte/store';



// const api_url = app_.env.API_URL;
// const token = get(auth).token;

const params = {};



// async function testAccessToken(token) {

// 	let test_token_url = `${api_url}auth/login/test-token`;

// 	const response = await fetch(test_token_url, {
// 		method: 'POST',
// 		headers: {
// 			Authorization: `Bearer ${token}`,
// 		},
// 	});

// 	return response.ok;

// }


// testAccessToken(token).then(data => {

// 	// alert(data);

// 	if (!data) {
// 		auth.set({token: null});
// 		navigateTo('/auth/login');
// 	}

// }).catch(error => {
// 	auth.set({token: null});
// 	navigateTo('/auth/login');
// });


export let currentRoute;

</script>


<style>

</style>


<Navbar />
<div id="errors-layout" class="errors-layout layout">
	<Route {currentRoute} {params} />
</div>
<Footer />


